import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarHelpButtonComponent } from './omnibar-help-button';
export * from './omnibar-help-button-adapter';
export * from './omnibar-help-button-constants';
export * from './omnibar-help-button-foundation';
export * from './omnibar-help-button';
export function defineOmnibarHelpButtonComponent() {
    defineCustomElement(OmnibarHelpButtonComponent);
}
